module.exports = __webpack_public_path__ + "img/p13.44a2ab0d.png";